// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.c-editable-form {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  height: 100%;
}

.c-label_disabled_true {
  opacity: 0.3;
}

.group-edit-form {
  padding: 1em;
  width: 100%;
}

.c-input_numeric {
  width: 104%;
}

.c-input_large2 {
  width: 100%;
}

.invalid-input {
  border: 1px solid var(--colorError);
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
